import { controls } from "../../controls";
const rprbi12 = {
  label: "FI & KCC",
  starting: true,
  url: "FI & KCC",
  pageLabel: "FI & KCC",
  pageType: "history",
  // filteraction: true,
  filter: [
    ...controls.magicDateLabel({ tab: "filter", label: "From Date", width: "col-sm-2", target: "from_date" }),
    ...controls.magicDate({ tab: "filter", name: "from_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),

    ...controls.magicDateLabel({ tab: "filter", label: "As on Date", width: "col-sm-2", target: "as_on_date" }),
    ...controls.magicDate({ tab: "filter", name: "as_on_date", width: "col-sm-2", dateType: "ontype", default: "sd" }),
  ],
  form: [],
  history: {
    perPage: 10,
    reportHeader: "RBI FI & KCC",
    filterable: true,
    sortable: true,
    defaultsTo: 0,
    pdfProps: { pageSize: "A3", pageOrientation: "landscape" },

    textReportProps: {
      'LBS': {
        filename: `RBI-FIandKCC-$pageData.as_on_date$.txt`,
        format: {},
        separator: "|"
      },
    },
    displayColumns: [
      {
        Header: "State Code",
        accessor: "state_code_RBI",
      },
      {
        Header: "District Code",
        accessor: "district_code_RBI",
      },
      {
        Header: "Block Code",
        accessor: "block_code",
      },
      {
        Header: "No of Inactive BCs",
        accessor: "inactive_bc",
      },
      {
        Header: "Active RuPay card No.",
        accessor: "rupay_pmjdy",
      },
      {
        Header: "1st Time active card No.",
        accessor: "first_timers",
      },
      {
        Header: "Aadhaar Authenticated SB AC",
        accessor: "auth",
      },
      {
        Header: "RuPay card Issued in KCC",
        accessor: "kcc_count",
      },
    ]
  }
};
export default rprbi12;